var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentIncomplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M481 160h729v313H481z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "109.9%",
    height: "123%",
    x: "-4.9%",
    y: "-8.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.595547634 0 0 0 0 0.599104196 0 0 0 0 0.608072917 0 0 0 0.27619646 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCFCFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M1.197 27.53H0V0h71.818v27.53h-3.59L34.711 51.47 1.197 27.53z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "g",
    width: 57.455,
    height: 43.091,
    x: 5.985,
    y: 8.379,
    rx: 2.4
  }), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: "126.1%",
    height: "134.8%",
    x: "-13.1%",
    y: "-17.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.206020542 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: "112%",
    height: "133.9%",
    x: "-6%",
    y: "-16.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: "167.1%",
    height: "241%",
    x: "-33.3%",
    y: "-69.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.236423733 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1030-208H410v864h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1030 -208)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 79,
    r: 79,
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC300",
    d: "M43.09 74.212h-.067L76.15 48.434a3.6 3.6 0 0 1 4.472.04l31.893 25.738v45.476a3.6 3.6 0 0 1-3.6 3.6H46.691a3.6 3.6 0 0 1-3.6-3.6V74.212z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.09 46.682)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD95E",
    d: "M34.712 51.47L1.197 27.53h67.03z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#f)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.6,
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.758 14.364)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.955,
    cy: 17.955,
    r: 17.955,
    fill: "#FFF",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#06BB72",
    d: "M27.304 12.144L16.16 23.939l-5.783-5.04"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M64.636 31.4L35.91 46.082 4.788 31.4l29.89 21.268z",
    filter: "url(#h)",
    mask: "url(#e)",
    opacity: 0.286
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD95E",
    d: "M36.526 4.1L64.261 31.12H.693l27.438-27a6 6 0 0 1 8.395-.021z",
    filter: "url(#i)",
    transform: "translate(45.485 92.167)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFC300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M77.77 28.727l.033 6.584M64.36 33.754l3.03 5.485M54.466 43.535l5.674 2.657M88.3 38.344l3.029-5.485M95.27 46.467l5.675-2.658"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE2E3D",
    fillRule: "nonzero",
    d: "M57.449 59.842v-2.387l-1.495 1.422-1.525-1.422-1.465 1.422-1.494-1.422v7.536c0 .464.37.842.83.842h.019a.836.836 0 0 0 .825-.842v-1.442h2.63v1.442c0 .464.371.842.832.842h.017c.46 0 .832-.378.832-.842v-3.982l-.006-1.167zm-4.305 2.15v-.684c0-.739.592-1.337 1.315-1.337.724 0 1.315.598 1.315 1.337v.684h-2.63z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIncomplete);
export default __webpack_public_path__ + "static/media/payment-incomplete.5503b6231df22db2af54fed254f68aaf.svg";
export { ForwardRef as ReactComponent };